import React, { useEffect } from "react";
import { Shield, Award, Users, CheckCircle, Phone } from "lucide-react";
import { useNavigate } from "react-router-dom";
import "./home.css";
import { MdArrowOutward } from "react-icons/md";
import builingSeftyntes from "../assets/buildingseafty.jpg";
import invisibleGrills from "../assets/invisiblegrills/4.jpg";
import sportnets from "../assets/sportsnet.jpg";
import mokeySeaftynets from "../assets/monkeySeaftynets.jpg";
// import petsSeaftyNets from "../assets/petsSeaftynets.jpg";
import industrialSeaftyNets from "../assets/industrialSeaftyNets.jpg";
import ductareaNets from "../assets/ductareanets.webp";
import childerSeaftyNets from "../assets/childerSeaftynets.jpg";
import petsSeaftyNets from "../assets/galleryassests/8.jpg";
import birdspikes from "../assets/birdspikes.jpg";

import HomeSlider from "./HomeSlider";

import { Helmet } from "react-helmet-async";

const ContactInfoItem = ({ Icon, text }) => (
  <p className="flex items-center px-4 py-2 bg-[#2c3639] text-white font-medium rounded hover:bg-[#a27b5c] transition-colors duration-300">
    <Icon className="h-5 w-5 mr-2" />
    {text}
  </p>
);

const Home = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "smooth",
    });
  }, []);

  const schemaData = {
    "@context": "https://schema.org",
    "@type": "WebPage",
    name: "Balcony Pigeon Net Installation in Bangalore – Clean, Safe & Bird-Free Balconies",
    url: "https://www.anssafetynets.com",
    description:
      "Balcony Pigeon Net Installation in Bangalore – Clean, Safe & Bird-Free Balconies. Looking for a trusted pigeon net installation service in Bangalore? We provide top-quality, durablebalcony bird netting solutions to protect your home from pigeons and other nuisance birds. Whether you're in an apartment, villa, or commercial space, our expert team delivers professional and affordable anti-bird net installation across all areas of Bangalore",
    keywords: [
      "pigeon net for balcony in Bangalore",
      "balcony bird netting Bangalore",
      "anti pigeon net installation Bangalore",
      "bird net service near me",
      "pigeon control Bangalore",
      "balcony safety nets Bangalore",
      "balcony net near me",
      "pigeon net near me",
      "balcony net Bengaluru",
      "pigeon net Bengaluru",
      "bird netting near me",
      "bird net installation",
      "balcony net for pigeon",
      "pigeon net for balcony",
    ],

    breadcrumb: {
      "@type": "BreadcrumbList",
      itemListElement: [
        {
          "@type": "ListItem",
          position: 1,
          name: "Home",
          item: "https://www.anssafetynets.com",
        },
        {
          "@type": "ListItem",
          position: 2,
          name: "Safety Nets",
          item: "https://www.anssafetynets.com",
        },
      ],
    },
    publisher: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      logo: {
        "@type": "ImageObject",
        url: "https://www.anssafetynets.com/logo.png",
        width: 250,
        height: 100,
      },
      contactPoint: [
        {
          "@type": "ContactPoint",
          telephone: "+91-7416116587",
          contactType: "Customer Service",
          areaServed: "IN",
          availableLanguage: ["English", "Kannada"],
        },
      ],
      sameAs: [
        "https://www.facebook.com/profile.php?id=61572534324956",
        "https://www.instagram.com/anssafetynets_bengaluru/",
      ],
    },
    mainEntity: {
      "@type": "Organization",
      name: "ANS Safety Nets",
      address: {
        "@type": "PostalAddress",
        streetAddress:
          "74/9, 5th Cross Rd, Muthyala Nagar, Bahubali Nagar, Jalahalli, Bengaluru, Karnataka 560013",
        addressLocality: "Bengaluru",
        addressRegion: "KA",
        postalCode: "560013",
        addressCountry: "IN",
      },
      service: [
        {
          "@type": "Service",
          name: "Safety Nets",
          areaServed: "Bengaluru",
        },
      ],
    },
  };

  return (
    <>
      <Helmet>
        <title>
          Balcony safety Nets/ pigeon Net installation Bengaluru call 7416116587
        </title>
        <meta
          name="description"
          content="Balcony Pigeon Net Installation in Bangalore – Clean, Safe & Bird-Free Balconies. Looking for a trusted pigeon net installation service in Bangalore? We provide top-quality, durable
balcony bird netting solutions to protect your home from pigeons and other nuisance birds. Whether
you're in an apartment, villa, or commercial space, our expert team delivers professional and affordable
anti-bird net installation across all areas of Bangalore"
        />
        <meta
          name="keywords"
          content="pigeon net for balcony in Bangalore
balcony bird netting Bangalore
anti pigeon net installation Bangalore,
bird net service near me,
pigeon control Bangalore,
balcony safety nets Bangalore.
Balcony net near me
pigeon Net near me
Balcony net Bengaluru
Pigeon Net Bengaluru
Bird Netting near me 
Bird net installation 
Balcony net for Pigeon 
Pigeon Net for balcony "
        />
        <meta name="author" content="ANS Safety Nets, Bengaluru" />
        <link rel="canonical" href="https://www.anssafetynets.com" />
        <script type="application/ld+json">{JSON.stringify(schemaData)}</script>
      </Helmet>

      <div>
        <HomeSlider />
        {/* 
      offer section */}
        <div className="py-10 bg-[#2c3639] text-center text-3xl px-4 relative offer">
          <div className="clippath"></div>
          <h2 className="text-[#fff]">
            Upto 18% Discount | 3 to 5 Years Life of the Material | 1 Year Free
            Maintenance only at ANS Safety Nets
          </h2>
        </div>

        {/* Features Section */}
        <div className="py-[50px] bg-gray-50">
          <div className="max-w-7xl mx-auto px-4">
            <h2 className="text-3xl font-bold text-center mb-12">
              Why Choose ANS Safety Nets?
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-8">
              {[
                {
                  icon: Shield,
                  title: "Superior Quality",
                  description:
                    "We prioritize your safety with premium materials and advanced manufacturing techniques. Each safety net undergoes rigorous testing to ensure it provides maximum safety for your balconies, industrial areas, or any application. Whether it's balcony safety nets in Bengaluru or industrial safety nets, you can trust us for excellence.",
                },
                {
                  icon: Award,
                  title: "Certified Products",
                  description:
                    "Our products are certified to meet international safety standards. From children safety nets to pets safety nets, every product is designed for durability and reliability. We take pride in offering the best safety nets in Bengaluru that comply with global benchmarks.",
                },
                {
                  icon: Users,
                  title: "Expert Team",
                  description:
                    "Our team consists of experienced professionals with extensive knowledge in safety solutions. Whether you're installing monkey safety nets or cricket practice nets in Bengaluru, our experts ensure flawless execution tailored to your needs.",
                },
                {
                  icon: CheckCircle,
                  title: "Reliable Support",
                  description:
                    "We understand the importance of dependable customer service. That’s why we offer 24/7 support and maintenance. From ducteria nets to bird spikes in Bengaluru, our team is here to assist you every step of the way.",
                },
              ].map((feature, index) => (
                <div
                  key={index}
                  className="text-center p-6 homecardsborderdesign"
                >
                  <feature.icon className="h-12 w-12 text-[#2c3639] mx-auto mb-4" />
                  <h3 className="text-xl font-semibold mb-2">
                    {feature.title}
                  </h3>
                  <p className="text-gray-600">{feature.description}</p>
                  <span className="textundelinecardbrake"></span>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* redirect to other subapages */}

        <div className="py-20">
          <div className="max-w-7xl mx-auto px-4">
            <h2 className="text-3xl font-bold text-center mb-12">
              Explore Our Safety Solutions
            </h2>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
              {[
                {
                  path: "/invisiblegrills",
                  title: "Invisible grills",
                  description:
                    "Stylish grills ensuring safety without blocking your view.",
                  url: invisibleGrills,
                },
                {
                  path: "/balconysafenets",
                  title: "Balcony Safety Nets",
                  description:
                    "Protect your loved ones with sturdy balcony nets.",
                  url: builingSeftyntes,
                },
                {
                  path: "/childernsafetynets",
                  title: "Children Safety Nets",
                  description:
                    "Ensure your children's safety with our specialized nets.",
                  url: childerSeaftyNets,
                },
                {
                  path: "/industrialsafetynets",
                  title: "Industrial Safety Nets",
                  description: "Robust solutions for industrial safety needs.",
                  url: industrialSeaftyNets,
                },
                {
                  path: "/petssafetynets",
                  title: "Pets Safety Nets",
                  description: "Keep your pets safe and secure.",
                  url: petsSeaftyNets,
                },
                {
                  path: "/ducterianets",
                  title: "Duct area Nets",
                  description: "High-quality nets for duct areas.",
                  url: ductareaNets,
                },
                {
                  path: "/monkeysafetynets",
                  title: "Monkey Safety Nets",
                  description:
                    "Effective solutions to prevent monkey intrusions.",
                  url: mokeySeaftynets,
                },
                {
                  path: "/cricketpracticenets",
                  title: "Cricket Practice Nets",
                  description:
                    "Train safely with our durable cricket practice nets.",
                  url: sportnets,
                },
                {
                  path: "/birdspikes",
                  title: "Bird Spikes",
                  description:
                    "Prevent birds from nesting or perching on surfaces.",
                  url: birdspikes,
                },
              ].map((item, index) => (
                <div
                  key={index}
                  className=" rounded-lg shadow-lg hover:shadow-xl transition-shadow duration-300 text-center border border-gray-200 "
                >
                  <img
                    src={item.url}
                    alt="ANS SAFETY NETS ,safety nets in bengaluru,"
                    tittle="ANS SAFETY NETS ,safety nets in bengaluru,safety nets, no 01 safety nets Balcony Safety Nets,
    Children Safety Nets,
    Industrial Safety Nets,
    Pets Safety Nets,
    Ducteria Nets,
    Monkey Safety Nets,
    Cricket Practice Nets,
    Bird Spikes"
                    className="w-full h-64 object-cover rounded-t-lg "
                  />
                  <div className="p-3 lg:p-6 ">
                    <h3 className="text-xl font-semibold mb-2 text-[#262626]">
                      {item.title}
                    </h3>
                    <p className="text-gray-600 mb-4">{item.description}</p>

                    <div className="flex items-center justify-between gap-4">
                      <ContactInfoItem
                        Icon={Phone}
                        text={
                          <a
                            href="tel:+917416116587"
                            className="text-sm hover:underline sm:text-base "
                          >
                            7416116587
                          </a>
                        }
                      />

                      <a
                        href={item.path}
                        className="flex items-center px-4 py-2 bg-[#2c3639] text-white  rounded hover:bg-[#a27b5c]  transition-colors duration-300 text-sm-base hover:underline sm:text-base exlorebtn-home"
                      >
                        Explore{" "}
                        <span className="text-2xl ">
                          <MdArrowOutward />
                        </span>
                      </a>
                    </div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* <TestimonialSlider /> */}

        {/* CTA Section */}
        <div className="bg-[#d8d9dd] py-20">
          <div className="max-w-7xl mx-auto px-4 text-center">
            <h2 className="text-3xl font-bold text-black mb-4">
              Ready to Enhance Your Safety?
            </h2>
            <p className="text-xl text-black mb-8">
              Contact us today for a free consultation and quote.
            </p>
            <button
              onClick={() => {
                navigate("/contact");
                window.scrollTo({
                  top: 0,
                  behavior: "smooth",
                });
              }}
              className="homecontactnavigatebtn"
            >
              Contact Us
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default Home;
